import React from "react";
import "../IVRSolutions/IVRSolutions.css";
import {
  FaCheckCircle,
  FaClock,
  FaRandom,
  FaCoins,
  FaSmile,
  FaHeartbeat,
  FaUniversity,
  FaShoppingCart,
  FaGraduationCap,
  FaBuilding,
  FaPlane,
} from "react-icons/fa";
import centerImage from "../../pages/IVRSolutions/assets/ss.png";
import flowIvrImage from "./assets/flow-ivr.jpeg";

const IVRSolutions = () => {

  return (
    <>
      <div className="services-banner">
        <div className="overlay"></div>
        <div className="content">
          <div className="line"></div>
          <div>
            <h1>Interactive Voice Response</h1>
            <p>
              In these days of speedy-moving virtual international, consumer
              expectations are higher than ever. 
              Businesses need rapid,<br /> dependable, and professional verbal
              exchange structures to stay aggressive. This is where{" "}
              <b className="bold">interactive voice response </b> <br /> technology plays a vital role.
            </p>
            <p>
              <span className="home">Home</span> → Service → Interactive Voice
              Response
            </p>
          </div>
        </div>
      </div>
      <section className="ivr-section">
        <div className="ivr-container">
          <section className="about-sectionvv">
            <div className="about-containervv">
              <div className="about-contentvv">
                <span className="about-tagvv">Interactive Voice Response</span>

                <h1>What is an Interactive Voice Response System?</h1>

                <p className="about-descvv">
                  <b className="bold"> Interactive voice reaction</b> is an automatic telephony
                  generation that interacts with callers, collects data, and
                  routes calls to the suitable branch without human
                  intervention. A modern-day interactive voice response device
                  lets clients:
                </p>
                <div className="about-featuresvv">
                  <div className="feature-rightvv">
                    <p>
                      <FaCheckCircle /> Navigate menus the usage of voice or
                      keypad
                    </p>
                    <p>
                      <FaCheckCircle /> Access records immediately
                    </p>
                    <p>
                      <FaCheckCircle /> Connect to the proper department
                      quickly.
                    </p>
                  </div>
                </div>
                <p>
                  A superior IVR phone system integrates with CRM and databases
                  to provide personalized consumer reports. This makes your
                  interactive voice response carrier smarter and extra green.
                </p>
                <br />
              </div>
            </div>
            <section className="services-bb">
              <div className="container-bb">
                <h5 className="subheading-bb">IVR Call Flow</h5>
                <h2 className="heading-bb">
                 Telecom / Cloud Communication IVR Call Flow
                </h2>

                <div style={{ marginTop: "24px" }}>
                  <img
                    src={flowIvrImage}
                    alt="IVR call flow diagram"
                    style={{ width: "100%", maxWidth: "1100px", height: "auto", display: "block", margin: "0 auto" }}
                  />
                </div>
              </div>
            </section>
            <section className="why-section">
              <div className="why-left">
                <span className="tags">WHY CHOOSE US</span>

                <h1>Why Your Business Needs an IVR Phone System</h1>
                <p>
                  Implementing a reliable <b className="bold">IVR Phone System</b> with an
                  advanced interactive voice response company can considerably
                  decorate your enterprise operations and improve customer
                  pleasure.
                </p>
              </div>
              <br />
              <div className="why-container">
                <div className="why-right">
                  <div className="card">
                    <h3><FaClock className="why-icon" /> 24/7 Availability</h3>
                    <p>
                      A well-designed interactive voice response device ensures
                      your commercial enterprise is always available, even
                      outside working hours.
                    </p>
                  </div>

                  <div className="card">
                    <h3><FaRandom className="why-icon" /> Faster Call Routing</h3>
                    <p>
                      An efficient IVR smartphone device directs calls right
                      away to the right department, decreasing wait times.
                    </p>
                  </div>

                  <div className="card">
                    <h3><FaCoins className="why-icon" /> Cost Efficiency</h3>
                    <p>
                      By automating repetitive duties, an interactive voice
                      response machine reduces the need for massive support
                      groups.
                    </p>
                  </div>

                  <div className="card">
                    <h3><FaSmile className="why-icon" /> Improved Customer Experience</h3>
                    <p>
                      An expert interactive voice reaction provider guarantees
                      clients get short and accurate help.
                    </p>
                  </div>

                </div>
              </div>
            </section>
            <section className="why-sectionz">
              <h2>Key Features of Our Interactive Voice Response Service</h2>

              <p className="why-descz">
                We provide a fully customizable interactive voice response
                provider designed to fulfill your commercial enterprise wishes.
              </p>

              <div className="why-containerz">
                <div className="why-gridz">
                  <div className="why-colz">
                    <p>
                      <FaCheckCircle />
                      Smart Call Routing
                    </p>
                    <p>
                      <FaCheckCircle /> Custom IVR Flow
                    </p>
                    <p>
                      <FaCheckCircle /> Multi-Language Support
                    </p>
                  </div>

                  <div className="why-colz">
                    <p>
                      <FaCheckCircle /> CRM Integration
                    </p>
                    <p>
                      <FaCheckCircle /> CRM Integration
                    </p>
                  </div>
                </div>
              </div>
            </section>
            <section className="industriesss">
              <h2>Industries We Serve</h2>
              <p>
                Our <b className="bold">interactive voice response service </b> is designed for a
                wide range of industries. Each interactive voice response system
                is customized to match the specific needs of your industry and
                business communication requirements.
              </p>
              <br />
              <div className="industries-containerss">
                <div className="industries-rightss">
                  <div className="cardss"><FaHeartbeat className="industry-icon" /> Healthcare</div>
                  <div className="cardss"><FaUniversity className="industry-icon" /> Banking & Finance</div>
                  <div className="cardss"><FaShoppingCart className="industry-icon" /> E-commerce</div>
                  <div className="cardss"><FaGraduationCap className="industry-icon" /> Education</div>
                  <div className="cardss"><FaBuilding className="industry-icon" /> Real Estate</div>
                  <div className="cardss"><FaPlane className="industry-icon" /> Travel & Hospitality</div>
                </div>
              </div>
            </section>
            <section className="whyss">
              <p className="subtitless">WHY CHOOSE US</p>
              <h2 className="titless">
                Why Choose Our Interactive Voice Response Service
              </h2>
              <p>
                Choosing the right <b className="bold">interactive voice response service</b>{" "}
                provider is essential for your business success.
              </p>

              <div className="why-containerss">
                <div className="center-imagess">
                  <img src={centerImage} alt="transport" />
                </div>

                <div className="left-cardsss">
                  <div className="cardsss left-card card1">
                    <span>Easy Setup</span>
                  </div>
                  <div className="cardsss left-card card2">
                    <span>Custom Solutions</span>
                  </div>
                </div>

                <div className="right-cards">
                  <div className="cardsss left-card card3">
                    <span>Affordable Pricing</span>
                  </div>
                  <div className="cardsss right-card card4">
                    <span>24/7 Support</span>
                  </div>
                </div>
              </div>
            </section>
          </section>
        </div>
      </section>
    </>
  );
};

export default IVRSolutions;
